
<!-- CAROSELLO SCHEDE -->
<div class="container mb-5 modulo carousel-schede">
  <div class="row">
    <div class="col-12">
      <swiper [config]="config">

        <div class="row">
          <div class="col-12 text-center">
            <h2 style="font-size:1.4rem;" class="mb-3">{{campi.TITOLO?.valore}}</h2>
          </div>
          <div class="col-12 text-center">
            <h3 class="mb-3" style="font-size:1.2rem;font-weight: 400;">{{campi.SOTTOTITOLO?.valore}}</h3>
          </div>
          <div class="col-12 text-center text-md-right">
            <a class="btn btn-stem btn-alt mb-3 mr-1 rounded-circle swiper-button-prev-stem pulsante-slider" role="button" data-slide="prev">
              <i class="fas fa-angle-left"></i>
            </a>
            <a class="btn btn-stem btn-alt mb-3 rounded-circle swiper-button-next-stem pulsante-slider" role="button" data-slide="next">
              <i class="fas fa-angle-right"></i>
            </a>
            <div class="slider-pager"></div>
          </div>
        </div>

        <div class="swiper-wrapper">
          <div class="swiper-slide" *ngFor="let scheda of campi.SCHEDE?.valore">
            <app-card [scheda]="scheda" (aggiungiAlCarrelloClicked)="aggiungiAlCarrello(scheda)"></app-card>
          </div>
        </div>
      </swiper>
    </div>
  </div>
</div>
<!-- //CAROSELLO SCHEDE -->
